import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setDisplayEntryOnPage: YJSChangeHandler<
  DatabaseChangeType.SET_DISPLAY_ENTRY_ON_PAGE
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.displayEntryOnPage = change.displayEntryOnPage;
  });
};
